

















































import { Component, Vue, Watch } from "vue-property-decorator";
import { UserModule } from "@/store/modules/user";
import { updateAdmin, AdminCommonReq } from "@/api/admin";
import { ResCode, Admin } from "@/api/baseDefine";
import { getQiniuToken, QiniuTokenRes } from "../../api/admin";
@Component
export default class About extends Vue {}
